var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"middleItem"},[_c('div',[_c('areaMap')],1),_c('div',[_c('project')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }